import { gql } from '@apollo/client';
const IS_LOGIN = gql `
  query IsUserLoggedIn {
    isUserLoggedIn @client(always: true)
  }
`;
export default IS_LOGIN;
